import dynamic from "next/dynamic";
import Head from "next/head";
import { useContext, useEffect } from "react";
import { newVehicles, vehicles } from "../../../../src/constants/vehicleData";
import { imagesWEBP } from "../../../../src/constants/webpImages";
import { Context } from "../../../../src/context/context";
import { sendAnalytics } from "../../../../src/utils/analyticsCommon";
import {
  generateProductSchema,
  createOffer,
  createBrand,
  createPropertyValue,
} from "../../../../src/utils/ProductSchemaGenerator.js";
import {
  generateFAQPageSchema,
  convertFAQsToQuestions,
} from "../../../../src/utils/FAQPageSchemaGenerator.js";
import { vehicleFAQs } from "../../../../src/constants/brandFaqs";
const ElectricPassengerVehicleLandingPage = dynamic(
  () =>
    import(
      "../../../../src/modules/ElectricPassengerVehicleLandingPage/ElectricPassengerVehicleLandingPage"
    ),
  { suspense: true }
);
import {
  TITLE,
  META_NAME,
  META_CONTENT,
  META_KEYWORDS_NAME,
  META_KEYWORDS_CONTENT,
  KEY_SPECIFICATION_HEADER,
  HIGHLIGHTS_HEADER,
  SUB_TEXT,
  BENEFITS_HEADER,
  VEHICLE_FEATURE_HEADER,
  BRAND_DEALER_HEADER,
  BRAND_DEALER_DESCRIPITION,
  FAQ_HEADER_TEXT,
  H1_HEADING,
  VEHICLE_LINK,
  BREADCRUMB_ITEMS,
  BREADCRUMB_SCHEMA,
} from "../../../../src/constants/PassengerLandingPageContants/MontraLandingPageContants";

const PRICE_CITIES = ["pune", "mumbai", "bangalore", "hyderabad", "chennai", "kolkata", "delhi-ncr", "jaipur", "lucknow", "ahmedabad", "indore"];
const SECONDARY_HEADER_ITEMS = [
  { label: "Montra Super Auto", sectionId: "section-header" },
  { label: "Price", sectionId: "section-price" },
  { label: "Specification", sectionId: "section-specification" },
  { label: "Summary", sectionId: "section-summary" },
];

export default function VehicleModelDetails({
  brand,
  vehicleModel,
  vehicleDataLocal,
  productSchema,
  faqPageSchema,
}) {
  const noentryData = [
    {
      id: 1,
      imageName: imagesWEBP?.vehicleBenefitsMontraSuperAuto0,
    },
    {
      id: 2,
      imageName: imagesWEBP?.vehicleBenefitsMontraSuperAuto1,
    },
    {
      id: 3,
      imageName: imagesWEBP?.vehicleBenefitsMontraSuperAuto2,
    },
    {
      id: 4,
      imageName: imagesWEBP?.vehicleBenefitsMontraSuperAuto3,
    },
  ];
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_${brand}_${vehicleModel}` },
      "en"
    );
  }, [brand, vehicleModel]);

  const state = useContext(Context);
  let location =
    state?.selectedState === "Others" ? "India" : state?.selectedState;

  {
    console.log("vehicleDataLocal", vehicleDataLocal);
  }

  //We need to add SEO Meta info later
  return (
    <>
      <Head>
        <title>Montra Super Auto Price in 2026 - Range, Specification & Reviews | Turno</title>
        <meta
          name="description"
          content="Looking for Montra super Auto price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
        />
        <meta
          name="keywords"
          content="Montra super Auto, Montra Super Auto price, electric passenger vehicle, Montra electric auto, Super Auto specifications, electric vehicle range, Montra EV, electric passenger vehicle price, Turno"
        />
        <meta name="author" content="Turno" />
        <meta
          name="url"
          content="https://www.turno.club/electric-commercial-vehicles/Montra/super-auto"
        />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta
          property="og:url"
          content="https://www.turno.club/electric-commercial-vehicles/Montra/super-auto"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Montra Super Auto Price in 2026 - Range, Specification & Reviews | Turno"
        />
        <meta
          property="og:description"
          content="Looking for Montra super Auto price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        
        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Looking for Montra super Auto price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
        />
        <meta
          name="twitter:title"
          content="Montra Super Auto Price in 2026 - Range, Specification & Reviews | Turno"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta
          name="twitter:url"
          content="https://www.turno.club/electric-commercial-vehicles/Montra/super-auto"
        />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />
        <link rel="canonical" href={VEHICLE_LINK} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productSchema),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqPageSchema),
          }}
          defer
        />
      </Head>

      <ElectricPassengerVehicleLandingPage
        title={TITLE}
        metaName={META_NAME}
        metaContent={META_CONTENT}
        brand={brand}
        vehicleModel={vehicleModel}
        location={location}
        vehicleDataLocal={vehicleDataLocal}
        vehicleName={"montraePV"}
        META_KEYWORDS_NAME={META_KEYWORDS_NAME}
        META_KEYWORDS_CONTENT={META_KEYWORDS_CONTENT}
        KEY_SPECIFICATION_HEADER={KEY_SPECIFICATION_HEADER}
        HIGHLIGHTS_HEADER={HIGHLIGHTS_HEADER}
        SUB_TEXT={SUB_TEXT}
        BENEFITS_HEADER={BENEFITS_HEADER}
        VEHICLE_FEATURE_HEADER={VEHICLE_FEATURE_HEADER}
        BRAND_DEALER_HEADER={BRAND_DEALER_HEADER}
        BRAND_DEALER_DESCRIPITION={BRAND_DEALER_DESCRIPITION}
        FAQ_HEADER_TEXT={FAQ_HEADER_TEXT}
        imagesWEBP={imagesWEBP}
        noentryData={noentryData}
        H1_HEADING={H1_HEADING}
        BREADCRUMB_ITEMS={BREADCRUMB_ITEMS}
        secondaryHeaderItems={SECONDARY_HEADER_ITEMS}
        priceCities={PRICE_CITIES}
      />
    </>
  );
}

export const getStaticProps = (context) => {
  let vehicleData = [...vehicles, ...newVehicles];

  const brand = "Montra";
  const vehicleModel = "super-auto";

  let vehicleDataLocal = vehicleData?.filter(function (vehicle) {
    return vehicle?.vehicle_path_id === `${vehicleModel}`;
  });

  let latestVehiclesInfo = vehicleData?.filter((vehicle) => {
    return vehicle?.vehicle_path_id !== `${vehicleModel}`;
  });

  // Constants are already imported at the top of the file

  // Generate Product Schema
  const vehicleDataItem = vehicleDataLocal?.[0];
  const productImages = vehicleDataItem?.images_287 || [
    imagesWEBP?.vehicleBenefitsMontraSuperAuto0,
    imagesWEBP?.vehicleBenefitsMontraSuperAuto1,
    imagesWEBP?.vehicleBenefitsMontraSuperAuto2,
    imagesWEBP?.vehicleBenefitsMontraSuperAuto3,
  ].filter(Boolean);

  // Get price range from vehicle data
  const getPriceRange = () => {
    if (!vehicleDataItem?.prices) return { lowPrice: 380000, highPrice: 400000 };
    const allPrices = [];
    Object.values(vehicleDataItem.prices).forEach((statePrices) => {
      Object.values(statePrices).forEach((variant) => {
        if (variant.price) {
          allPrices.push(variant.price * 100000); // Convert lakhs to rupees
        }
      });
    });
    return {
      lowPrice: Math.min(...allPrices),
      highPrice: Math.max(...allPrices),
    };
  };

  const priceRange = getPriceRange();

  const productSchema = generateProductSchema({
    name: "Montra Super Auto",
    description: SUB_TEXT || "Montra Super Auto electric passenger auto rickshaw",
    image: productImages,
    url: VEHICLE_LINK,
    brand: createBrand({
      name: "Montra",
      url: "https://www.turno.club/electric-commercial-vehicles/Montra",
    }),
    category: "Electric Passenger Vehicle",
    model: "Super Auto",
    manufacturer: {
      "@type": "Organization",
      name: "Montra Electric",
    },
    offers: createOffer({
      offerCount: 3,
      lowPrice: priceRange.lowPrice,
      highPrice: priceRange.highPrice,
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      url: VEHICLE_LINK,
      seller: {
        "@type": "Organization",
        name: "Turno",
        url: "https://www.turno.club/",
      },
    }),
    additionalProperty: [
      vehicleDataItem?.seatingCapacity
        ? createPropertyValue({ name: "Seating Capacity", value: vehicleDataItem.seatingCapacity })
        : null,
      vehicleDataItem?.range
        ? createPropertyValue({ name: "Range", value: vehicleDataItem.range })
        : null,
      vehicleDataItem?.batteryCapacity
        ? createPropertyValue({
            name: "Battery Capacity",
            value: vehicleDataItem.batteryCapacity,
          })
        : null,
      vehicleDataItem?.batteryVoltage
        ? createPropertyValue({
            name: "Battery Voltage",
            value: vehicleDataItem.batteryVoltage,
          })
        : null,
    ].filter(Boolean),
    keywords: "Montra Super Auto, electric passenger vehicle, Montra electric auto",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    itemCondition: "https://schema.org/NewCondition",
    isFamilyFriendly: true,
    slogan: "Electric passenger auto rickshaw for urban transportation",
  });

  // Generate FAQPage Schema
  const faqQuestions = convertFAQsToQuestions(vehicleFAQs?.montraePV || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: FAQ_HEADER_TEXT || "FAQs on Montra Super Auto",
    description: `Frequently asked questions about Montra Super Auto electric passenger vehicle. ${SUB_TEXT || ""}`,
    url: VEHICLE_LINK,
    headline: FAQ_HEADER_TEXT || "FAQs on Montra Super Auto",
    keywords: "Montra Super Auto, FAQ, electric passenger vehicle",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: BREADCRUMB_SCHEMA,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: productImages[0] || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
    speakable: {
      "@type": "SpeakableSpecification",
      xPath: [
        "/html/head/title",
        "/html/head/meta[@name='description']/@content",
      ],
    },
  });

  return {
    props: { 
      brand, 
      vehicleModel, 
      vehicleDataLocal, 
      latestVehiclesInfo,
      productSchema,
      faqPageSchema,
    },
  };
};

